// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabButton--vopx2 {
  color: #343c42;
  text-transform: uppercase;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-wrap: anywhere;
  hyphens: auto;
  font-size: 12px;
}[dir] .tabButton--vopx2 {
  background-color: #cecece;
  border: none;
  border-bottom: 3px solid #cecece;
  border-radius: 0;
  padding: 0.3rem 0.3rem;
}[dir=ltr] .tabButton--vopx2 {
  border-right: 1px solid #ffffff;
}[dir=rtl] .tabButton--vopx2 {
  border-left: 1px solid #ffffff;
}

.tabButton--vopx2:hover {
  text-decoration: none;
}

[dir] .tabButton--vopx2:hover {
  border-bottom: 3px solid #e6512d;
}

.tabButtonActive--xu_9M {
  color: #000;
  text-transform: uppercase;
  text-decoration: none;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-wrap: anywhere;
  hyphens: auto;
  font-size: 12px;
}

[dir] .tabButtonActive--xu_9M {
  background-color: #fff;
  border: none;
  border-bottom: 3px solid #e6512d;
  padding: 0.3rem 0.3rem;
}

[dir=ltr] .tabButtonActive--xu_9M {
  border-right: 1px solid #ffffff;
}

[dir=rtl] .tabButtonActive--xu_9M {
  border-left: 1px solid #ffffff;
}

@media (min-width: 768px) {
  .tabButton--vopx2 {
    font-size: 16px;
  }
  [dir] .tabButton--vopx2 {
    padding: 0.5rem 1rem;
  }

  .tabButtonActive--xu_9M {
    font-size: 16px;
  }

  [dir] .tabButtonActive--xu_9M {
    padding: 0.5rem 1rem;
  }
}

.tabButtonActive--xu_9M:hover,
.tabButtonActive--xu_9M:focus {
  text-decoration: none;
}

.tableHeadline--c1ice {
  font-weight: 600;
}

.filterWrapper--FmG75 {
  display: flex;
  justify-content: center;
  align-items: center;
}

[dir] .filterWrapper--FmG75 {
  padding: 10px;
}

[dir] .radioButtonLabel--u44oq {
  margin-bottom: 0;
}

[dir=ltr] .radioButtonLabel--u44oq {
  margin-left: 15px;
}

[dir=rtl] .radioButtonLabel--u44oq {
  margin-right: 15px;
}

[dir=ltr] .radioButtonLabel--u44oq:first-child {
  margin-left: 0;
}

[dir=rtl] .radioButtonLabel--u44oq:first-child {
  margin-right: 0;
}

[dir=ltr] .radioButton--bCCQq {
  margin-right: 5px;
}

[dir=rtl] .radioButton--bCCQq {
  margin-left: 5px;
}

.dataTableTitle--PoDiO {
  font-family: museo-sans;
}

[dir] .dataTableTitle--PoDiO {
  margin-bottom: 15px;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/InfoPagesDataTable/styles.css"],"names":[],"mappings":"AAAA;EAME,cAAc;EACd,yBAAyB;EAEzB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB,CAjBA;EACE,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAEhC,gBAAgB;EAGhB,sBAAsB;AASxB,CAjBA;EAIE,+BAA+B;AAajC,CAjBA;EAIE,8BAA+B;AAajC;;AAEA;EAEE,qBAAqB;AACvB;;AAHA;EACE,gCAAgC;AAElC;;AAEA;EAKE,WAAW;EAEX,yBAAyB;EACzB,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAhBA;EACE,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;EAGhC,sBAAsB;AAUxB;;AAhBA;EAIE,+BAA+B;AAYjC;;AAhBA;EAIE,8BAA+B;AAYjC;;AAEA;EACE;IACE,eAAe;EAEjB;EAHA;IAEE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EAEjB;;EAHA;IAEE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AALA;EACE,aAAa;AAIf;;AAEA;EAEE,gBAAgB;AAClB;;AAHA;EACE,iBAAiB;AAEnB;;AAHA;EACE,kBAAiB;AAEnB;;AAEA;EACE,cAAc;AAChB;;AAFA;EACE,eAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAFA;EACE,gBAAiB;AACnB;;AAEA;EACE,uBAAuB;AAEzB;;AAHA;EAEE,mBAAmB;AACrB","sourcesContent":[".tabButton {\n  background-color: #cecece;\n  border: none;\n  border-bottom: 3px solid #cecece;\n  border-right: 1px solid #ffffff;\n  border-radius: 0;\n  color: #343c42;\n  text-transform: uppercase;\n  padding: 0.3rem 0.3rem;\n  text-decoration: none;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-wrap: anywhere;\n  hyphens: auto;\n  font-size: 12px;\n}\n\n.tabButton:hover {\n  border-bottom: 3px solid #e6512d;\n  text-decoration: none;\n}\n\n.tabButtonActive {\n  background-color: #fff;\n  border: none;\n  border-bottom: 3px solid #e6512d;\n  border-right: 1px solid #ffffff;\n  color: #000;\n  padding: 0.3rem 0.3rem;\n  text-transform: uppercase;\n  text-decoration: none;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow-wrap: anywhere;\n  hyphens: auto;\n  font-size: 12px;\n}\n\n@media (min-width: 768px) {\n  .tabButton {\n    font-size: 16px;\n    padding: 0.5rem 1rem;\n  }\n\n  .tabButtonActive {\n    font-size: 16px;\n    padding: 0.5rem 1rem;\n  }\n}\n\n.tabButtonActive:hover,\n.tabButtonActive:focus {\n  text-decoration: none;\n}\n\n.tableHeadline {\n  font-weight: 600;\n}\n\n.filterWrapper {\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.radioButtonLabel {\n  margin-left: 15px;\n  margin-bottom: 0;\n}\n\n.radioButtonLabel:first-child {\n  margin-left: 0;\n}\n\n.radioButton {\n  margin-right: 5px;\n}\n\n.dataTableTitle {\n  font-family: museo-sans;\n  margin-bottom: 15px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabButton": `tabButton--vopx2`,
	"tabButtonActive": `tabButtonActive--xu_9M`,
	"tableHeadline": `tableHeadline--c1ice`,
	"filterWrapper": `filterWrapper--FmG75`,
	"radioButtonLabel": `radioButtonLabel--u44oq`,
	"radioButton": `radioButton--bCCQq`,
	"dataTableTitle": `dataTableTitle--PoDiO`
};
export default ___CSS_LOADER_EXPORT___;
